import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import ContentFrom from "../../components/contentfrom";

function Gettouch(props) {
  return (
    <div className="gettouch p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="example" data-text="Conect">
              <h2>Discuss Your Project Now!</h2>
            </div>
            <p>
              As one of the best software development companies in Saudi Arabia,
              we're here to make your concept a reality. Drive your business
              growth with our customized solutions and cutting-edge technical
              skills. Our developers are all set to carry out your idea, whether
              you're in Saudi Arabia, the USA, UK, Canada, or the GCC. You can
              schedule a free consultation with us to get an estimated cost of
              custom software development project as we discuss your
              requirements and goals in detail. Get in touch with us!
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto offset-lg-1"
          >
            <ContentFrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Gettouch;
